module.exports = __webpack_public_path__ + "static/fonts/Mont-ExtraLightItalic.e1f7753.woff";